import { App as AntApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './App';
import { AuthProvider } from './auth/AuthContext';
import './styles/global.css';

// 与 vite.config.ts 的 base 保持一致；BASE_URL 末尾带斜杠，basename 需去掉。
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#176a4d', colorInfo: '#176a4d', borderRadius: 8, colorBgLayout: '#f3f5f2', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif' }, components: { Layout: { siderBg: '#112c24', headerBg: '#ffffff' }, Menu: { darkItemBg: '#112c24', darkSubMenuItemBg: '#0d241d', darkItemSelectedBg: '#1b684e' } } }}>
      <AntApp>
        <BrowserRouter basename={basename}>
          <AuthProvider><AppRoutes /></AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </StrictMode>,
);
